import type { ExternalErrorQueryParamValue } from '@apps/main/new-desktop/core/models/navigation';

import type { Serializer } from '@libs/utils';

export const ExternalErrorSerializer: Serializer<ExternalErrorQueryParamValue> =
  {
    serialize: (
      externalErrorQueryParam: ExternalErrorQueryParamValue
    ): ExternalErrorQueryParamValue => externalErrorQueryParam,
    deserialize: (
      externalErrorQueryParam: ExternalErrorQueryParamValue
    ): ExternalErrorQueryParamValue => externalErrorQueryParam,
  };
